import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$defaultlxi0kykibhye as close$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.c1c_1 = _channel;
      }
      lx(cause) {
        if (this.yw())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().a15(null == null ? this.fw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.nx(tmp);
      }
      p1b(cause, $super) {
        return this.mx(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      nx(cause) {
        var exception = this.dx(cause);
        this.c1c_1.lx(exception);
        this.qx(exception);
      }
      u1a() {
        return this.c1c_1.u1a();
      }
      *b1b(element, $completion) {
        yield* this.c1c_1.b1b(element, $completion);
        return Unit_instance;
      }
      c1b(element) {
        return this.c1c_1.c1b(element);
      }
      l1b(cause) {
        return this.c1c_1.l1b(cause);
      }
      q1b(handler) {
        this.c1c_1.q1b(handler);
      }
      *e1b($completion) {
        return yield* this.c1c_1.e1b($completion);
      }
      p1() {
        return this.c1c_1.p1();
      }
    }
    protoOf($).n1b = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
